import axios from 'axios'
import { BIOSERVER } from '@svort/component'

class Axios {
    constructor() {
        this.axios = axios.create({
            baseURL: `https://${BIOSERVER}/`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
    }

    async post(...params) {
        try {
            const response = await this.axios.post(...params);

            return response.data;
        } catch (error) {
            console.error(error.message);

            return { status: 'error', message: error.message };
        }
    }

    async get(...params) {
        try {
            const response = await this.axios.get(...params);
            
            return response.data;
        } catch (error) {
            console.error(error.message);

            return { status: 'error', message: error.message };
        }
    }
}

export default new Axios();